<template>
  <div class="error-container screenBackground">
    <div class="error-content">
      <div class="error-title">
        <v-icon
          large
          color="error"
          class="mr-3"
        >
          mdi-alert-circle
        </v-icon>
        <h2>Inactive Feature</h2>
      </div>
      <div class="error-text">
        <p>This page is not available for your account.</p>
        <p>Please contact us to enable this feature.</p>
        <router-link to="/">
          Return to Home
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InactiveFeature",
};
</script>

<style scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.error-content {
  text-align: center;
  max-width: 500px;
  padding: 30px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

.error-title {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d32f2f;
  margin-bottom: 20px;
}

.error-text {
  font-size: 16px;
  margin-bottom: 25px;
}

.error-actions {
  margin-top: 10px;
}
</style>
